import axios from 'axios';

export default {
  state: {
    blog: [],
    section: {},
    loading: false,
    error: null,
    blogLoaded: false,
    noMoreBlog: false
  },
  mutations: {
    SET_BLOG(state, {blog, page}) {
      if (page > 1) {
        state.blog = state.blog.concat(blog.data.items)
      }
      else
        state.blog = blog.data.items;
      if (state.blog.length >= blog.data.total)
        state.noMoreBlog = true;
      state.blogLoaded = true; // Устанавливаем флаг, что данные загружены
    },
    SET_BLOG_LOADING(state, status) {
      state.blogLoading = status;
    },
    SET_BLOG_ERROR(state, error) {
      state.blogError = error;
    },
    UNSET_BLOG(state) {
      state.blogLoaded = false;
      state.blogLoading = false;
      state.blog = [];
      state.noMoreBlog = false;
    },
  },
  actions: {
    async fetchBlog({ commit, state }, {page}) {
      if (page == 1)
        commit('UNSET_BLOG');

      try {
        commit('SET_BLOG_LOADING', true);
        // Используем относительный путь, который будет добавлен к baseURL из глобальных настроек
        const response = await axios.get('api/blog/', {
          params: {
            page: page
          }
        });
        commit('SET_BLOG', {blog:response.data, page:page});
        commit('SET_BLOG_ERROR', null);
      } catch (error) {
        commit('SET_BLOG_ERROR', error.message || 'Ошибка при загрузке категорий');
        console.error('Error fetching blog:', error);
      } finally {
        commit('SET_BLOG_LOADING', false);
      }
    }
  },
  getters: {
    blog: state => state.blog,
    blogLoading: state => state.blogLoading,
    blogError: state => state.blogError,
    blogLoaded: state => state.blogLoaded,
    noMoreBlog: state => state.noMoreBlog
  }
}